import { setCookie } from './cookies'
import { getInitialLanguageCode } from 'common/utils/context'
import { logGaEvent } from 'common/utils/analytics'
import { getInitialUserCurrencyCode } from 'common/utils/context.js'
import { loadFooterHTML } from './footerHtml'

const footerSelector = '.footer'
const currencyDropDownSelector = '.footer__select > select[name="currency"]'
const languageDropDownSelector = '.footer__select > select[name="language"]'
const footerHTMLPromiseCache = {}

const attachFooterEventListeners = () => {
  attachDropdownChangedEventListeners(currencyDropDownSelector, onCurrencyDropdownChange)
  attachDropdownChangedEventListeners(languageDropDownSelector, onLanguageDropdownChange)
}

const attachDropdownChangedEventListeners = (domSelector, onChangeCallbackHandler) => {
  const dropdown = document.querySelector(domSelector)
  if (dropdown) {
    dropdown.addEventListener('change', onChangeCallbackHandler)
  }
}

const attachFooterClickHandlerToContext = () => {
  if (!window.r2r.footer) {
    window.r2r.footer = window.r2r.footer || {}
    if (!window.r2r.footer.click) {
      window.r2r.footer.click = (action) => {
        if (action.includes('hotels') && r2r.commonUI != null) {
          const destination = r2r.commonUI.getDestination()
          r2r.HotelExit.hotelRedirect({
            label: 'Footer',
            destination,
            requestId: r2r.globals.requestId,
          })
        }
      }
    }

    if (!window.r2r.footer.clickExit) {
      window.r2r.footer.clickExit = (action) => {
        window.r2r.footer.click(action)
      }
    }
  }
}

const onCurrencyDropdownChange = (e) => {
  var currencyCode = e.currentTarget.value

  // note: using getInitialUserCurrencyCode only works because the page is forced to refresh
  // on language change
  logGaEvent(
    'UserPreferences',
    'Changed:Language:Footer',
    `${window.loggingCurrencyCode }>${currencyCode}`.toLowerCase(),
  )

  // update variable for future logging
  window.loggingCurrencyCode  = currencyCode


  if (window && window.userPreferencesDropDown) {
    window.userPreferencesDropDown.changeCurrency(currencyCode)
  } else {
    setCookie('currency', currencyCode, 1000)
    location.reload()
  }
}

const onLanguageDropdownChange = (e) => {
  var languageCode = e.currentTarget.value

  // note: using getInitialLanguageCode only works because the page is forced to refresh
  // on language change
  logGaEvent(
    'UserPreferences',
    'Changed:Language:Footer',
    `${window.loggingLanguageCode}>${languageCode}`.toLowerCase(),
  )

  // update variable for future logging
  window.loggingLanguageCode = languageCode

  if (window && window.userPreferencesDropDown) {
    window.userPreferencesDropDown.changeLanguage(languageCode)
    updateFooterLanguage(languageCode)
  } else {
    setCookie('language', languageCode, 1000)
    location.reload()
  }
}

const initializeFooterHTMLPromiseCache = () => {
  const footer = document.querySelector(footerSelector)
  if (footer) {
    const footerHTML = footer.outerHTML
    footerHTMLPromiseCache.en = new Promise(resolve => resolve({ data: footerHTML }))
  }
}

document.addEventListener('DOMContentLoaded', () => {
  attachFooterEventListeners()
  attachFooterClickHandlerToContext()
  initializeFooterHTMLPromiseCache()

  // used solely for logging language and currency changes in the footer
  window.loggingLanguageCode = getInitialLanguageCode()
  window.loggingCurrencyCode  = getInitialUserCurrencyCode()

  const userLanguage = getInitialLanguageCode()
  if (userLanguage !== 'en') {
    // Immediately update the footer so that it's correctly localised if necessary.
    updateFooterLanguage(getInitialLanguageCode())
  }
})

const updateSelect = (targetValue, selectSelector) => {
  const selectMenu = document.querySelector(selectSelector)
  const opts = selectMenu.options
  for (let i = 0; i < opts.length; i++) {
    const opt = opts[i]
    if (opt.value == targetValue) {
      selectMenu.selectedIndex = i
      break
    }
  }
}

window.changeCurrency = (currencyString) => {
  updateSelect(currencyString, currencyDropDownSelector)
}

window.changeLanguage = (languageString) => {
  updateSelect(languageString, languageDropDownSelector)
}

const updateFooterLanguage = (languageCode) => {
  const promise = footerHTMLPromiseCache[languageCode] || getFooterHTML(languageCode)
  promise.then(insertFooterHTML)
  return promise
}

const getFooterHTML = (languageCode) => {
  const promise = loadFooterHTML(languageCode)
  footerHTMLPromiseCache[languageCode] = promise
  return promise
}

const insertFooterHTML = (httpResponse) => {
  const footer = document.querySelector(footerSelector)
  footer.outerHTML = httpResponse.data
  setTimeout(attachFooterEventListeners)
}

/* eslint-disable no-unused-vars */
// TODO: fix this hack to get these icons on the page for the footer
const appleinc = import(/* webpackPrefetch: -10 */ 'styles/icons/appleinc.svg')
const android = import(/* webpackPrefetch: -10 */ 'styles/icons/android.svg')
const facebook = import(/* webpackPrefetch: -10 */ 'styles/icons/facebook.svg')
const linkedin = import(/* webpackPrefetch: -10 */ 'styles/icons/linkedin.svg')
const twitter = import(/* webpackPrefetch: -10 */ 'styles/icons/twitter.svg')
/* eslint-enable no-unused-vars */

export {
  updateFooterLanguage,
}
